import { FC } from 'react';
import MinkaAllocateLedger from './MinkaAllocateLedger';
import UseMinkaAllocateLedger from './UseMinkaAllocateLedger';

const MinkaAllocateLedgerContainer: FC = () => {
  return <MinkaAllocateLedger {...UseMinkaAllocateLedger()} />;
};

export default MinkaAllocateLedgerContainer;
